module.exports = __webpack_public_path__ + "static/img/8.4ee852f0.png";